export enum CustomEvents {
    cannedResponseClicked = "cannedResponseClicked",
}
